import tbNav from './tb-nav.component'

export default angular
  .module('tb.nav', [])
  .component('tbNav', tbNav)
  .name
